import { Component, OnInit } from '@angular/core';
import { NbDialogRef } from '@nebular/theme';
import * as momentHijri from 'moment-hijri';
import { Partner } from '../../models/partner';
import { Router } from '@angular/router';


@Component({
  selector: 'app-partner-details',
  templateUrl: './partner-details.component.html',
  styleUrls: ['./partner-details.component.scss'],
})
export class PartnerDetailsComponent implements OnInit {
  model = {} as Partner;

  constructor(private diag: NbDialogRef<PartnerDetailsComponent>,
        private route : Router
  ) {}

  ngOnInit() {
      this.route.events.subscribe(()=>{
      this.diag.close('false');
     });
  }

  close() {
    this.diag.close();
  }

   getHijriDate(date) {
      return momentHijri(date, 'YYYY-MM-DD').format('iYYYY/iM/iD');
    }
}
